import axiosPrivate from "./axiosPrivate";

const getUsuariosParaPlanilla = () => {
    return axiosPrivate.get(`rh-administracion/usuarios`)
      .then(response => response.data);
};

const getPlanillaRh = (periodo_planilla) => {
    return axiosPrivate.get(`rh-administracion`, { params: { periodo_planilla } })
      .then(response => response.data);
};

const guardarPlanillaRh = (data) => {
    return axiosPrivate.post(`rh-administracion`, data)
      .then(response => response.data);
};

const validarPlanillaRh = (periodo_planilla, perfil_id) => {
    return axiosPrivate.post(`rh-administracion/validar`, { periodo_planilla, perfil_id })
      .then(response => response.data);
};

const actualizarPago = (data) => {
    return axiosPrivate.post(`rh-administracion/actualizar-pago`, data)
      .then(response => response.data);
};

const RhAdministracionService = {
    getUsuariosParaPlanilla,
    getPlanillaRh,
    guardarPlanillaRh,
    validarPlanillaRh,
    actualizarPago
};

export default RhAdministracionService;
